import styled from "styled-components";

export const ContainerDropZone = styled.div`
  background: var(--background-color);
  padding: 10px;
`;

export const DropZoneGeneral = styled.div`
  align-items: center;
  box-sizing: border-box;
  height: 100% auto;
  margin: 0;
  margin-bottom: 10px;
  top: 0px;
  width: 100%;
`;

export const DropZoneContent = styled.button`
  background: var(--background-color);
  color: var(--color);
  border-radius: 4px;
  box-shadow: var(--box-shadow);
  padding: 4px;
  width: 100%;
  border: none;
`;

export const DropZone = styled.div`
  padding: 10px;
  border: 1px dashed #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: height 0.2s ease;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  background: var(--background-color);
  display: grid;
  padding: 20px;
  place-items: start;
  border-radius: 4px;
`;

export const Title = styled.h1`
  font-size: 3.2rem;
  margin-bottom: 2rem;
  color: var(--color);
`;

export const LogDetailsItem = styled.div`
  color: var(--color);
  p {
    color: var(--color);
    line-height: 1.2;
    width: 80ch;
    b {
      color: var(--danger);
    }
  }
`;

export const SubTitle = styled.h3`
  font-size: 2rem;
  color: var(--color);
  padding: 10px 0;
`;
